<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '140px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
          <el-form-item label="用户姓名" prop="userName">
          <el-input v-model="dataForm.userName" placeholder="用户姓名"></el-input>
      </el-form-item>
          <el-form-item label="申请人手机" prop="userPhone">
          <el-input v-model="dataForm.userPhone" placeholder="申请人手机"></el-input>
      </el-form-item>
          <el-form-item label="经纪人ID" prop="inviteUserId">
          <el-input v-model="dataForm.inviteUserId" placeholder="经纪人ID"></el-input>
      </el-form-item>
          <el-form-item label="业务流水唯一编号" prop="bizFlow">
          <el-input v-model="dataForm.bizFlow" placeholder="业务流水唯一编号"></el-input>
      </el-form-item>



      <el-form-item label="状态" prop="status">
        <el-select v-model="dataForm.status" filterable clearable placeholder="请选择状态">
            <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-input v-model="dataForm.status" placeholder="申请中/完成申请/审核通过/审核未通过/已核额/未放款/放款成功(字典配置)"></el-input> -->
      </el-form-item>
      <el-form-item label="进件状态" prop="nextStatus">
          <!-- <el-input v-model="dataForm.nextStatus" placeholder="申请中/完成申请/审核通过/审核未通过/已核额/未放款/放款成功(字典配置)"></el-input> -->
          <el-select v-model="dataForm.nextStatus" filterable clearable placeholder="请选择进件状态">
            <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="产品CODE" prop="productCode">
          <el-input v-model="dataForm.productCode" placeholder="产品CODE"></el-input>
      </el-form-item>
          <el-form-item label="产品名称" prop="productName">
          <el-input v-model="dataForm.productName" placeholder="产品名称"></el-input>
      </el-form-item>
      <el-form-item label="投资时间" prop="investTime">
          <!-- <el-input v-model="dataForm.investTime" placeholder="投资时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.investTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="失败原因" prop="failMsg">
          <el-input v-model="dataForm.failMsg" placeholder="失败原因"></el-input>
      </el-form-item>
          <el-form-item label="核额金额" prop="realAmount">
          <el-input v-model="dataForm.realAmount" placeholder="核额金额"></el-input>
      </el-form-item>
      <el-form-item label="核额时间" prop="realTime">
          <!-- <el-input v-model="dataForm.realTime" placeholder="核额时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.realTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="放款金额" prop="loanAmount">
          <el-input v-model="dataForm.loanAmount" placeholder="放款金额"></el-input>
      </el-form-item>
      <el-form-item label="放款时间" prop="loanTime">
          <!-- <el-input v-model="dataForm.loanTime" placeholder="放款时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.loanTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
              <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      statusList:[],
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        userName: '',
        userPhone: '',
        inviteUserId: '',
        bizFlow: '',
        status: '',
        nextStatus: '',
        productCode: '',
        productName: '',
        investTime: '',
        failMsg: '',
        realAmount: '',
        realTime: '',
        loanAmount: '',
        loanTime: '',
        remark: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userPhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        inviteUserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bizFlow: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        nextStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        investTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        failMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        realAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        realTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loanAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loanTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.getentryStatusOptions()
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slproducttender/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          status: res.data.status + '',
          nextStatus: res.data.nextStatus + '',
        }
        console.log(this.dataForm)
      }).catch(() => {})
    },
    //初始进件状态下拉框中的选项
    async getentryStatusOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=entryStatus`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.statusList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.statusList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slproducttender/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
